import React from 'react';

import { ButtonPrimary, Button } from '@primer/components'


export default function(props) {
  const label = props.isInProgress ? 'Working' : props.label
  const className = props.isInProgress ? 'AnimatedEllipsis' : ''
  if (props.secondary) {
    return <Button className={className} disabled={props.disabled} onClick={props.onClick} style={props.style}>{label}</Button>
  }
  return <ButtonPrimary disabled={props.readOnly} onClick={props.onClick} style={props.style}>{label}</ButtonPrimary> 
}